/* The quiet row beside Due now: what the book still has to be told.
 *
 * On every station, and only ever a count until somebody taps it. It opens nothing
 * by itself and makes no sound, including on a failure: the client is already in the
 * chair, and this is for when the desk has a moment. With nothing open it draws
 * nothing at all. The rules and every sentence are in js/rules/pending-moves.js.
 */
import * as Vue from 'vue';
import { store } from '../store.js';

export const PendingMoves = {
  name: 'PendingMoves',
  setup: function () {
    var open = Vue.ref(false);
    return {
      open: open,
      lines: store.pendingMoveLines,
      toggle: function () { open.value = !open.value; },
      run: store.runPendingMove
    };
  },
  template: [
    '<div v-if="lines.length" class="pending-moves">',
    '  <button type="button" class="pending-moves__head" :aria-expanded="open ? \'true\' : \'false\'" @click="toggle">',
    '    <span class="quick-appts__label">Pending',
    '      <span class="quick-appts__n pending-moves__n">{{ lines.length }}</span></span>',
    '  </button>',
    '  <ul v-if="open" class="pending-moves__list">',
    '    <li v-for="p in lines" :key="p.item.id">',
    '      <div class="pending-moves__headline">{{ p.line.headline }}</div>',
    '      <div v-if="p.line.detail" class="pending-moves__detail">{{ p.line.detail }}</div>',
    '      <div v-if="p.line.note" class="warn-line">{{ p.line.note }}</div>',
    '      <button v-if="p.line.canSwap && p.item.plan && p.item.plan.wire && p.item.plan.wire.length"',
    '        type="button" class="btn btn--primary btn--sm" :disabled="p.busy"',
    '        @click="run(p.item.id)">{{ p.busy ? "Saving…" : p.line.action }}</button>',
    '    </li>',
    '  </ul>',
    '</div>'
  ].join('\n')
};
